export const profileKey = 'uuiurl6idb';
export const adapterType = 'idb';
export const CancelledTime = 'cancelledTime';
